import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiHeart,FiArrowUp,FiLinkedin,FiMail,FiPhone}=FiIcons;

const Footer=()=> {
  const scrollToTop=()=> {
    window.scrollTo({top: 0,behavior: 'smooth'});
  };

  const footerLinks={
    'Services': [
      'Performance Analytics',
      'Team Development',
      'Strategic Planning',
      'Athletic Coaching'
    ],
    'Resources': [
      'Performance Insights',
      'Training Methodologies',
      'Success Stories',
      'Consultation Guide'
    ],
    'Company': [
      'About Leigh',
      'Approach',
      'Client Success',
      'Contact Us'
    ]
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
          <div className="lg:col-span-2">
            <motion.div
              initial={{opacity: 0,y: 20}}
              whileInView={{opacity: 1,y: 0}}
              viewport={{once: true}}
              transition={{duration: 0.6}}
            >
              <img
                src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1759001394016-PJBZ1569.JPG"
                alt="Klein Sports Consulting"
                className="h-16 w-auto mb-4 brightness-0 invert"
              />
              <p className="text-gray-400 leading-relaxed mb-6 max-w-md">
                Elevating athletic performance through innovative consulting,data-driven insights,and proven methodologies. Excellence in every engagement.
              </p>
              <div className="flex space-x-4">
                <motion.a
                  href="https://www.linkedin.com/in/leighalanklein/"
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{scale: 1.1,y: -2}}
                  className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-orange-600 transition-all duration-300"
                >
                  <SafeIcon icon={FiLinkedin} className="w-5 h-5" />
                </motion.a>
                <motion.a
                  href="mailto:leigh@kleinsportsconsulting.com"
                  whileHover={{scale: 1.1,y: -2}}
                  className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-orange-600 transition-all duration-300"
                >
                  <SafeIcon icon={FiMail} className="w-5 h-5" />
                </motion.a>
              </div>
            </motion.div>
          </div>

          {Object.entries(footerLinks).map(([category,links],categoryIndex)=> (
            <motion.div
              key={category}
              initial={{opacity: 0,y: 20}}
              whileInView={{opacity: 1,y: 0}}
              viewport={{once: true}}
              transition={{duration: 0.6,delay: categoryIndex * 0.1}}
            >
              <h4 className="text-white font-semibold mb-4">{category}</h4>
              <ul className="space-y-2">
                {links.map((link)=> (
                  <li key={link}>
                    <a
                      href="#"
                      className="text-gray-400 hover:text-white transition-colors duration-200"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
          <motion.div
            initial={{opacity: 0,y: 20}}
            whileInView={{opacity: 1,y: 0}}
            viewport={{once: true}}
            transition={{duration: 0.6}}
            className="text-gray-400 text-sm mb-4 md:mb-0"
          >
            <p className="flex items-center">
              © 2024 Klein Sports Consulting. Crafted with
              <SafeIcon icon={FiHeart} className="w-4 h-4 text-red-400 mx-1" />
              for excellence
            </p>
          </motion.div>

          <div className="flex items-center space-x-6">
            <motion.div
              initial={{opacity: 0,y: 20}}
              whileInView={{opacity: 1,y: 0}}
              viewport={{once: true}}
              transition={{duration: 0.6,delay: 0.1}}
              className="flex space-x-6 text-sm text-gray-400"
            >
              <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
              <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
            </motion.div>

            <motion.button
              onClick={scrollToTop}
              initial={{opacity: 0,y: 20}}
              whileInView={{opacity: 1,y: 0}}
              viewport={{once: true}}
              transition={{duration: 0.6,delay: 0.2}}
              whileHover={{scale: 1.1,y: -2}}
              whileTap={{scale: 0.9}}
              className="w-12 h-12 bg-orange-600 rounded-xl flex items-center justify-center hover:bg-orange-700 transition-all duration-300 shadow-lg"
            >
              <SafeIcon icon={FiArrowUp} className="w-5 h-5 text-white" />
            </motion.button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;